import { render, staticRenderFns } from "./UpdateTicimaxChannel.vue?vue&type=template&id=7948188f&scoped=true"
import script from "./UpdateTicimaxChannel.vue?vue&type=script&lang=js"
export * from "./UpdateTicimaxChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateTicimaxChannel.vue?vue&type=style&index=0&id=7948188f&prod&lang=scss&scoped=true"
import style1 from "./UpdateTicimaxChannel.vue?vue&type=style&index=1&id=7948188f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948188f",
  null
  
)

export default component.exports